var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "content-header row d-print-none" }, [
      _c("div", { staticClass: "content-header-left col-md-7 col-12 mb-2" }, [
        _c("div", { staticClass: "row breadcrumbs-top" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("h2", { staticClass: "content-header-title float-left mb-0" }, [
              _vm._v("Settlement Report")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "breadcrumb-wrapper col-12" }, [
              _c("ol", { staticClass: "breadcrumb" }, [
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/home" } }, [
                      _vm._v(
                        "\n                                    " +
                          _vm._s(_vm.trans("general.home")) +
                          "\n                                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "li",
                  { staticClass: "breadcrumb-item" },
                  [
                    _c("router-link", { attrs: { to: "/settlement" } }, [
                      _vm._v(
                        "\n                                    Settlements\n                                "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("li", { staticClass: "breadcrumb-item active" }, [
                  _vm._v(
                    "\n                                Report\n                            "
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "content-header-right text-md-right col-md-5 col-12 d-md-block d-none"
        },
        [
          _c("div", { staticClass: "form-group breadcrum-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary btn-sm pull-right ml-1",
                on: { click: _vm.printSettlement }
              },
              [
                _c("i", { staticClass: "feather icon-printer" }),
                _vm._v(" Print Report\n                ")
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm pull-right ml-1",
                on: {
                  click: function($event) {
                    return _vm.$router.push("/settlement")
                  }
                }
              },
              [
                _c("i", { staticClass: "feather icon-list" }),
                _vm._v(" Back to Settlements\n                ")
              ]
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _vm.settlement
      ? _c("div", { staticClass: "content-body" }, [
          _c("section", { staticClass: "settlement-report-wrapper" }, [
            _c("div", { staticClass: "card report-card" }, [
              _c("div", { staticClass: "card-body report-body" }, [
                _c("div", { staticClass: "report-header" }, [
                  _c("div", [
                    _c("h2", { staticClass: "report-title" }, [
                      _vm._v("Settlement Report")
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "report-subtitle mb-0" }, [
                      _vm._v(_vm._s(_vm.companyName))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "report-meta text-md-right" }, [
                    _c("p", { staticClass: "mb-25" }, [
                      _c("strong", [_vm._v("Generated:")]),
                      _vm._v(" " + _vm._s(_vm.printedAt))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-25" }, [
                      _c("strong", [_vm._v("Report Date:")]),
                      _vm._v(" " + _vm._s(_vm.displayDate))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0" }, [
                      _c("strong", [_vm._v("Status:")]),
                      _vm._v(" " + _vm._s(_vm.settlement.status || "received"))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "report-banner" }, [
                  _c("div", { staticClass: "report-banner-item" }, [
                    _c("span", { staticClass: "report-label" }, [
                      _vm._v("Settlement Ref")
                    ]),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.settlement.settlement_reference || "-"))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "report-banner-item" }, [
                    _c("span", { staticClass: "report-label" }, [
                      _vm._v("Transaction Ref")
                    ]),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm.settlement.transaction_reference || "-")
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "report-banner-item" }, [
                    _c("span", { staticClass: "report-label" }, [
                      _vm._v("Payment Ref")
                    ]),
                    _vm._v(" "),
                    _c("strong", [
                      _vm._v(_vm._s(_vm.settlement.payment_reference || "-"))
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-md-12 mb-2" }, [
                    _c("div", { staticClass: "summary-box" }, [
                      _c("span", { staticClass: "report-label" }, [
                        _vm._v("Settlement Amount")
                      ]),
                      _vm._v(" "),
                      _c("h3", { staticClass: "mb-0" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("formatMoney")(
                              _vm.settlement.settlement_amount
                            )
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "report-section" }, [
                  _c("h4", { staticClass: "section-title" }, [
                    _vm._v("Settlement Details")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c(
                      "table",
                      { staticClass: "table table-bordered report-table" },
                      [
                        _c("tbody", [
                          _c("tr", [
                            _c("th", [_vm._v("Date")]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(_vm.displayDate))]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Event Type")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.settlement.event_type || "-"))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("th", [_vm._v("Session ID")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.settlement.session_id || "-"))
                            ]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Currency")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.settlement.currency_code || "NGN")
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("th", [_vm._v("Account Type")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.settlement.account_type || "-"))
                            ]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Bank Code")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.settlement.bank_code || "-"))
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "report-section" }, [
                  _c("h4", { staticClass: "section-title" }, [
                    _vm._v("Receiving Account")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-responsive" }, [
                    _c(
                      "table",
                      { staticClass: "table table-bordered report-table" },
                      [
                        _c("tbody", [
                          _c("tr", [
                            _c("th", [_vm._v("Account Name")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.settlement.account_name || "-"))
                            ]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Account Number")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.settlement.account_number || "-")
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("tr", [
                            _c("th", [_vm._v("Bank Name")]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(_vm._s(_vm.settlement.bank_name || "-"))
                            ]),
                            _vm._v(" "),
                            _c("th", [_vm._v("User")]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(_vm.userDisplay))])
                          ])
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "report-section d-print-none" }, [
                  _c("h4", { staticClass: "section-title" }, [
                    _vm._v("Raw Payload")
                  ]),
                  _vm._v(" "),
                  _c("pre", { staticClass: "payload-box" }, [
                    _vm._v(_vm._s(_vm.formattedPayload))
                  ])
                ]),
                _vm._v(" "),
                _vm._m(0)
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "report-footer" }, [
      _c("p", { staticClass: "mb-0" }, [
        _vm._v("This report was generated from the settlement webhook record.")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }